import React from "react"
import PropTypes from "prop-types"

import { Flex, Box } from "../../../ui"

const Axis = ({
  labels,
  getLabelRef,
  labelComponent,
  tickComponent,
  top,
  tickValues,
  tickNumbers,
  ticks,
  domain,
  scale,
  width,
  labelWidths,
}) => {
  scale.range([0, width])

  let displayedTicks = ticks
  if (!displayedTicks)
    displayedTicks =
      tickValues === "on"
        ? tickNumbers
          ? scale.ticks(tickNumbers)
          : scale.ticks()
        : tickValues === "auto"
        ? domain
        : null

  return (
    <Box position="absolute" left={0} right={0}>
      <Flex>
        {labels && labels[0] && (
          <Box
            ref={getLabelRef(0)}
            position="relative"
            top={`${top}px`}
            transform="translate(0, -50%)"
            transition="all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1)"
          >
            {labelComponent ? (
              labelComponent(labels[0], 0)
            ) : (
              <Box display="inline-block" p="0 0.5rem">
                {labels[0]}
              </Box>
            )}
          </Box>
        )}
        <Box flex="2">
          <Box
            position="relative"
            top={`${top}px`}
            height="1px"
            bg="gray.500"
            transition="all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1)"
          />

          {displayedTicks &&
            displayedTicks.map((tick, i) => (
              <Box
                key={`tick-${tick}`}
                position="absolute"
                top={!top ? top - 16 : top + 2}
                left={
                  labelWidths[0] ? labelWidths[0] + scale(tick) : scale(tick)
                }
                transform="translateX(-50%)"
                transition="all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1)"
              >
                {tickComponent ? (
                  tickComponent(tick, i)
                ) : (
                  <Box color="gray.500" fontSize="xs">
                    {tick}
                  </Box>
                )}
              </Box>
            ))}
        </Box>
        {labels && labels[1] && (
          <Box
            ref={getLabelRef(1)}
            position="relative"
            top={`${top}px`}
            transform="translate(0, -50%)"
            transition="all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1)"
          >
            {labelComponent ? (
              labelComponent(labels[1], 1)
            ) : (
              <Box display="inline-block" p="0 0.5rem">
                {labels[1]}
              </Box>
            )}
          </Box>
        )}
      </Flex>
    </Box>
  )
}

Axis.propTypes = {
  width: PropTypes.number,
  labels: PropTypes.array,
  getLabelRef: PropTypes.func,
  labelComponent: PropTypes.func,
  tickComponent: PropTypes.func,
  top: PropTypes.number,
  domain: PropTypes.array,
  tickValues: PropTypes.string,
  tickNumbers: PropTypes.number,
  ticks: PropTypes.array,
  labelWidths: PropTypes.array,
  scale: PropTypes.func,
}

export default Axis
